<template>
    <el-header class="header">
        <el-row align="middle" justify="space-between">
            <el-col :span="2"></el-col>
            <el-col :span="4">
                <el-image :src="logoImg" style="width: 180px; height: 60px"/>
            </el-col>
            <el-col :span="10">
                <el-menu background-color="#0055a5" mode="horizontal" text-color="#fff" @select="menuSelect">
                    <el-menu-item index="">首页</el-menu-item>
                    <el-menu-item index="about">关于我们</el-menu-item>
                    <el-menu-item index="services">客户服务</el-menu-item>
                    <el-menu-item index="projects">经典项目</el-menu-item>
                    <el-menu-item index="contact">联系我们</el-menu-item>
                    <el-menu-item>
                        <el-link href="http://erp.dsxtech.cn" target="_blank">订单管理</el-link>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="6">
                <div class="contact-number">
                    <Phone style="width: 1.5em; height: 1.5em; margin-right: 8px;"/>
                    <el-popover :show-arrow="false" title="微信扫码，成为好友" width="180">
                        <template #reference>
                            <p>181-2158-9080</p>
                        </template>
                        <el-image :src="codeImg" style="width: 150px; height: 150px;"/>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="2"></el-col>
        </el-row>
    </el-header>
</template>

<script setup>
import {ref} from "vue";
import {Phone} from "@element-plus/icons-vue";
import logo from '@/assets/logo.png'
import qrcode from '@/assets/qrcode.png';


const logoImg = ref(logo)
const codeImg = ref(qrcode)
const menuSelect = (index) => {
    const anchor = document.getElementById(index)
    if (anchor) {
        anchor.scrollIntoView({behavior: "smooth"})
    }
}
</script>

<style scoped>
.el-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    background-color: #0055a5;
}

.el-menu-item, .el-link {
    font-size: 16px;
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
    margin-top: -4px;
}

.contact-number {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
}
</style>